import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container as ContainerBase } from "components/misc/Layouts.js";
import logo from "../../images/mylogo.png";
import { ReactComponent as EmailIcon } from "../../images/mail-icon.svg";
import { ReactComponent as PhoneIcon } from "../../images/phone-icon.svg";
import { useTranslation } from "react-i18next";

const Container = tw(ContainerBase)`bg-gray-900 text-gray-100 -mx-8 -mb-8`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex items-center justify-center flex-col px-8`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-16`;
const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`;
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const SocialLinksContainer = tw.div`mt-10 md:flex inline-block`;
const SocialLink = styled.a`
	${tw`cursor-pointer mb-5 flex items-center text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
	svg {
		${tw`w-5 h-5 mr-2`}
	}
`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`;

export default () => {
	const { t } = useTranslation();

	return (
		<Container>
			<Content>
				<Row>
					<LogoContainer>
						<LogoImg src={logo} />
						<LogoText>{t("header.logoName")}</LogoText>
					</LogoContainer>
					<LinksContainer>
						<Link href="#home">{t("header.heroNavLink")}</Link>
						<Link href="#services">{t("header.featuresNavLink")}</Link>
						<Link href="#practice">{t("header.pricingNavLink")}</Link>
						<Link href="#about">{t("header.testimonialsNavLink")}</Link>
						<Link href="#expertise">{t("header.expertiseNavLink")}</Link>
					</LinksContainer>
					<SocialLinksContainer>
						<SocialLink href="tel:+ 37494755632">
							<PhoneIcon />
							+374 94 755 632
						</SocialLink>

						<SocialLink href="mailto:alfsemenguard@gmail.com">
							<EmailIcon />
							alfsemenguard@gmail.com
						</SocialLink>
						<SocialLink href="mailto:guard@alfsemen.am">
							<EmailIcon />
							guard@alfsemen.am
						</SocialLink>
						<SocialLink href="mailto:alfsemen@mail.ru">
							<EmailIcon />
							alfsemen@mail.ru
						</SocialLink>
						{/* <SocialLink href="https://youtube.com">
							<YoutubeIcon />
						</SocialLink> */}
					</SocialLinksContainer>
					<CopyrightText>
						&copy; Copyright {new Date().getFullYear()}, {t("header.logoName")}.{" "}
						{t("header.rightsReserved")}
					</CopyrightText>
				</Row>
			</Content>
		</Container>
	);
};
